import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { WpProvider } from '../../providers/wp/wp';
import { InAppBrowser, InAppBrowserObject } from "@ionic-native/in-app-browser";


import { PhcAppMenu, PhcApp, PhcAppMenuItem } from '../../classes/phc-app/phc-app';
import {HttpClient} from "@angular/common/http";
import { WebpageIframePage } from '../webpage-iframe/webpage-iframe';

/**
 * Generated class for the ReviewsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-reviews',
  templateUrl: 'reviews.html',
})
export class ReviewsPage {


  state: string = 'select';
  reviewMenu: PhcAppMenu|PhcAppMenuItem;
  phcApp: PhcApp;
  browser: InAppBrowserObject;
  reviewComplete = false;
  submitting = false;
  reviewMenuType: string;


  name = '';
  email = '';
  comments = '';

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              wp: WpProvider,
              private iab: InAppBrowser,
              // public linkService: PhcLinkServiceProvider,
              private http: HttpClient) {
    this.phcApp = wp.app;
    this.reviewMenu = this.phcApp.review_menu;
    this.reviewMenuType = this.reviewMenu.type;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReviewsPage');
  }

  positive(){
    this.state = '+';
    if (this.reviewMenu.type === 'item') {
      const link = this.reviewMenu.link;
      if (link.isWebpage() && link.webpageUrl) {

        if ((<any>window).isKiosk()) {
          this.navCtrl.remove(this.navCtrl.length() - 1, 1);
          this.navCtrl.push(WebpageIframePage, { url: link.webpageUrl });
        } else {
          switch(link.webpageTarget) {
            case 'iframe':
              this.navCtrl.remove(this.navCtrl.length() - 1, 1);
              this.navCtrl.push(WebpageIframePage, { url: link.webpageUrl });
              break;
            case 'native':
              this.browser = this.iab.create(link.webpageUrl, '_system', {
                location: 'no'
              });
              break;
            default:
              this.browser = this.iab.create(link.webpageUrl, '_blank', {
                location: 'no'
              });
              break;
          }
        }
      }
    }
  }

  negative(){
    this.state = '-';
  }

  reset() {
    this.state = 'select';
  }

  submitReview(){
    this.submitting = true;
    this.http.post(`https://phc-dev.eventerac.com/wp-json/phc/v1/submit-review?appId=${this.phcApp.id}`, {
      name: this.name,
      email: this.email,
      comments: this.comments,
    }).subscribe((resp) => {
      this.submitting = false;
      this.reviewComplete = true;
      this.name = '';
      this.email = '';
      this.comments = '';
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/reviews/reviews.ts